// Country data resolver - now reads from API-fetched cache in CountryContext
// Only getCountryFromPath remains as a pure utility
import { isValidCountryCode } from "@/data/countryData";

export function getCountryFromPath(pathname) {
  const parts = pathname.split('/').filter(Boolean);
  const first = parts[0] || "in";
  return isValidCountryCode(first) ? first : "in";
}
